// jshint ignore: start

export default {
  email_suggestion: {
    prefix: 'Vouliez-vous dire',
    suffix: ' ?',
    accept_label: "Remplacer l'e-mail par {{email}}",
  },
  auth_modal: {
    aria_label: {
      login: 'Se connecter à CGTrader',
      signup: 'S\'inscrire sur CGTrader',
    },
    header: {
      login_title: 'Ravi de vous revoir',
      signup_title: 'Créez votre compte',
      login_subtitle: 'Connectez-vous pour continuer à créer, concevoir et télécharger.',
    },
    social_divider: 'ou par e-mail',
    email_label: 'E-mail',
    email_placeholder: 'john@email.com',
    email_aria_label: 'Adresse e-mail',
    opt_in_label: 'Recevez les nouveautés produit, les actualités de la communauté et les offres.',
    submit_button: 'Continuer avec l\'e-mail',
    switch: {
      already_member: 'Déjà membre ? ',
      log_in: 'Se connecter',
      new_here: 'Vous êtes nouveau ? ',
      create_account: 'Créer un compte',
    },
    terms: {
      prefix: 'En continuant, j\'accepte les ',
      terms_link: 'Conditions Générales',
      middle: ' et la ',
      privacy_link: 'Politique de Confidentialité.',
      suffix: '',
    },
    code: {
      title: 'Vérifiez votre boîte de réception',
      subtitle_prefix: 'Nous avons envoyé un code à 6 chiffres à ',
      subtitle_suffix: '',
      email_fallback: 'votre e-mail',
      digit_aria_label: 'Chiffre {{number}}',
      error: 'Code d\'accès invalide. Veuillez réessayer.',
      resend_prompt: 'Vous ne l\'avez pas reçu ? ',
      resend_link: 'Renvoyer le code',
      resend_countdown: 'Renvoyer le code dans {{time}}',
      change_email_link: 'Changer d\'e-mail',
    },
    success: {
      login_title: 'Ravi de vous revoir',
      signup_title: 'Vous y êtes',
      signed_in_prefix: 'Connecté en tant que ',
      signed_in_suffix: '',
      signup_subtitle: 'Compte créé. Trouvons votre prochain modèle.',
    },
    password: {
      link: 'Se connecter avec un mot de passe',
      email_label: 'E-mail ou nom d\'utilisateur',
      title: 'Se connecter avec un mot de passe',
      subtitle: 'Saisissez votre e-mail et votre mot de passe pour continuer.',
      password_label: 'Mot de passe',
      forgot_password: 'Mot de passe oublié ?',
      submit_button: 'Se connecter',
      back: 'Retour',
      show_password: 'Afficher le mot de passe',
      hide_password: 'Masquer le mot de passe',
      error_generic: 'Une erreur est survenue. Veuillez réessayer plus tard.',
      required_notice: 'Veuillez également saisir votre mot de passe pour terminer la 2FA.',
      two_fa_code_label: 'Code de vérification',
    },
  },
  login: {
    generic_auth_error: 'Une erreur s\'est produite. Veuillez réessayer plus tard.',
  },
  itemPage: {
    licenseDropdown: {
      aiContactNote: {
        question: 'Besoin d\'une licence compatible avec l\'IA ?',
        linkText: 'Contactez notre équipe commerciale pour des options de licence de données Enterprise.',
      },
    },
    units: {
      mm: 'Millimètres',
      cm: 'Centimètres',
      in: 'Pouces',
      m: 'Mètres',
    },
    supportForm: {
      messageSent: 'Le message a été envoyé avec succès',
    },
  },
  listingPage: {
    pagination: {
      label: 'Pagination',
      firstPage: 'Aller à la première page',
      previousPage: 'Aller à la page précédente',
      nextPage: 'Aller à la page suivante',
      lastPage: 'Aller à la dernière page',
      page: 'Page {{number}}',
    },
    filters: {
      allFilters: 'TOUS LES FILTRES',
      resetFilters: 'Effacer',
      lastUsed: 'Dernier',
      fileFormat: 'Formats de fichier',
      searchPlaceholder: 'Tapez pour rechercher',
      price: {
        freeOnly: 'Gratuit uniquement',
        onSale: 'En solde (jusqu\'à {{percentage}} % de réduction)',
      },
      customPriceRange: 'Plage de prix personnalisée',
      quickSelections: 'Sélections rapides',
      subscriptionTier: {
        label: 'Abonnements',
        all: 'Tous',
      },
      pricePlaceholder: 'Prix',
      polyCountRange: 'Plage de polygones personnalisée',
      cardSize: 'Taille de la carte',
      cardVisibility: 'Paramètres de visibilité',
      visibility: {
        format: 'Format',
        price: 'Prix',
        cgtStandard: 'Norme CGT',
        type: 'Type',
        title: 'Titre',
        quickActionsOnHover: 'Actions rapides au survol',
        suggestions: 'Suggestions',
      },
      items: 'éléments',
      perPage: 'Par page :',
      wishListOnly: 'Afficher uniquement la liste de souhaits',
      hideOwnedModels: 'Masquer les modèles possédés',
      ownedModels: 'Uniquement les modèles achetés',
      sortBy: {
        default: 'Par défaut',
        label: 'Tri',
      },
      remaining: {
        label: 'Filtres',
      },
      showMoreButtonText: 'Afficher plus',
    },
    suggestedSearch: {
      showingResultsFor: 'Affichage des résultats pour',
      ifYouMeant: 'Si vous vouliez dire',
      tryThatSearchInstead: 'essayez cette recherche',
    },
    gallery: {
      formats: 'Formats',
      geometry: 'Géométrie',
      type: 'Type',
      details: 'Détails',
      unknown: 'Inconnu',
      polygons: '{{value}} polygones',
      vertices: '{{value}} sommets',
      previewing: 'APERÇU',
      types: {
        print_ready: 'Impression 3D',
        pbr: 'PBR',
        animated: 'Animé',
        rigged: 'Riggé',
        low_poly: 'Low-poly',
      },
      attributes: {
        textures: 'Textures',
        materials: 'Matériaux',
        uvw_mapping: 'Mappage UV',
        plugins_used: 'Plugins utilisés',
      },
    },
    actions: {
      preview: 'Aperçu',
      see_similar_models: 'Voir des modèles similaires',
      add_to_cart: 'Ajouter au panier',
      remove_from_cart: 'Retirer du panier',
      add_to_wishlist: 'Ajouter à la liste de souhaits',
      remove_from_wishlist: 'Retirer de la liste de souhaits',
      purchased: 'Acheté',
      open: 'Ouvrir',
    },
    download: {
      tooltip: 'Télécharger',
      header: 'Télécharger les fichiers',
      loading: 'Chargement des fichiers...',
      empty: 'Aucun fichier disponible au téléchargement.',
    },
    upsellBlock: {
      label: 'offre spéciale',
      heading: 'Téléchargez plus de modèles pour moins cher',
      bodyModels: '25 modèles par mois',
      bodyMiddle: ', à partir de ',
      bodyPrice: '9,99 $',
      cta: 'S\'abonner',
    },
    footerBanners: {
      title: 'Vous ne trouvez pas ce que vous cherchez ?',
      hire3dFreelancerBanner: {
        title: 'Engager un freelance 3D',
        description: 'Vous aurez l\'occasion de collaborer directement avec des designers 3D qualifiés sur une large gamme de projets personnalisés, y compris l\'impression 3D et l\'animation.',
        description2: 'Soumettez simplement une description de projet et recevez des devis de différents designers, vous permettant de sélectionner le plus adapté à vos besoins.',
        learnMoreButtonText: 'En savoir plus',
        learnMoreButtonUrl: '/fr/3d-modeling-jobs',
        postAProjectButtonText: 'Publier un projet',
      },
      searchSubscription: {
        title: 'Abonnez-vous à cette recherche',
        description: 'Nous mémoriserons vos paramètres de recherche et vous informerons lorsqu\'un nouveau résultat apparaîtra.',
        subscribe: 'S\'abonner',
        subscribing: 'Abonnement...',
        inputPlaceholder: 'Décrivez votre recherche plus en détail afin de nous aider à améliorer considérablement la bibliothèque de modèles 3D.',
      },
    },
  },
  browser: {
    filters: {
      cgt_standard_only: 'Norme CGT',
      cgt_standard_tooltip_title: 'Norme CGT - prêt à importer, aucun nettoyage nécessaire.',
      cgt_standard_tooltip_body: 'Vérification automatique de la géométrie, des UVs, des textures, de la configuration de scène et du nommage - fonctionne dans Blender, Maya, Unreal Engine, Unity et d\'autres outils majeurs. Vérifié automatiquement - non déclaré par le vendeur.',
    },
  },
  printModelPage: {
    sectionTitle: 'IMPRESSION 3D',
    heroTitle: 'Explorer des modèles pour l’impression 3D',
    sectionDescription: 'Modèles, fichiers et ressources 3D de haute qualité prêts pour une utilisation domestique ou professionnelle avec des imprimantes 3D FDM, SLA ou SLS.',
    placeholderText: 'Rechercher parmi plus de 800 000 modèles 3D à imprimer',
    allCategories: 'Parcourir tous les modèles',
    categorySectionTitle: "Fichiers d’impression 3D pour chaque idée",
    categorySectionDescription: "Parcourez des fichiers 3D de haute qualité conçus pour l’impression 3D FDM, SLA ou résine. Trouvez le modèle imprimé 3D parfait pour tout projet.",
    categorySectionButtonText: "Parcourir tous les fichiers",
    categorySectionBadgeText: "CATÉGORIES",
    budgetSectionTitle: "Découvrir des modèles adaptés à votre budget",
    budgetSectionDescription: "Découvrez des modèles rentables sans compromettre la qualité",
    BrowseAllText: 'Parcourir tout'
  },
  projects: {
    newestFirst: 'Newest first',
    highestBudget: 'Highest budget',
    fewestApplicants: 'Fewest applicants',
    modelingJob: '3d modeling job',
    myProjects: 'My 3D Projects',
    projects: '3D Projects',
    reviewProjectApplication: 'Review 3D Project application',
    startAProject: 'Start a Project',
    editProject: 'Edit Project',
    reviewProject: 'Review Project',
    applyToProject: 'Apply to 3D Project',
    editProjectApplication: 'Edit 3D Project application',
    learnMoreHowItWorks: 'Learn more how it works',
    projectsDashboard: 'Projects dashboard',
    cgtraderModelingJob: 'CGTrader 3D Modeling Jobs',
    software: '3D Software',
    skills: '3D Skills',
    searchPlaceholder: 'Search'
  },
  subscription_management: {
    empty_state: {
      message: 'Vous n\'avez pas d\'abonnement actif',
      view_essentials: 'Voir Essentials',
      view_essentials_premium: 'Voir les plans Essentials et Premium',
    },
    active: {
      plan_name: {
        essentials: 'CGTrader Essentials',
        premium: 'CGTrader Premium',
      },
      badge_cancelled: 'Annulé',
      cancel_button: "Annuler l'abonnement",
      renew_button: "Renouveler l'abonnement",
      reactivate_button: "Réactiver l'abonnement",
      annual_plan: 'Plan Annuel',
      monthly_plan: 'Plan Mensuel',
      renewal_message_prefix: 'Votre abonnement sera automatiquement renouvelé le ',
      renewal_message_suffix: '',
      monthly_renewal_message: 'Votre abonnement est renouvelé mensuellement',
      switch_plan: 'Changer de plan',
      billing: {
        billing_cycle: 'Cycle de facturation',
        next_billing_date: 'Prochaine date de facturation',
        no_renewal: 'Aucun frais supplémentaire',
        billing_suspended: 'Facturation suspendue',
        auto_resume: '{{date}} (reprise automatique)',
        pauses_on: 'Mise en pause le {{date}}',
        price: 'Prix',
        payment_method: 'Moyen de paiement',
        update: 'Mettre à jour',
      },
      usage: {
        progress_label: '{{used}} modèles téléchargés sur {{limit}}',
        paused_tooltip: 'Vous ne pouvez pas télécharger de modèles pendant que votre abonnement est en pause. Reprenez-le pour télécharger à nouveau.',
      },
      cancel_info: {
        title: "Que se passe-t-il si j'annule ?",
        keep_access: "Vous conserverez l'accès jusqu'à la fin de la période déjà payée",
        no_downloads: "Après l'annulation, vous ne pourrez plus télécharger de nouveaux modèles",
        keep_license: "Les modèles que vous avez déjà téléchargés restent sous licence pour les projets complétés lorsque l'abonnement était actif",
        cancellation_fee: "Les frais d'annulation ne s'appliquent pas si vous annulez dans les 45 premiers jours. Après cette période, des frais d'annulation correspondant à 50 % du solde restant de votre obligation contractuelle vous seront facturés.",
        cancellation_fee_new_yearly: "L'annulation de votre abonnement entraînera des frais d'annulation anticipée de 50 % du solde restant du contrat. Vous conserverez l'accès pendant la période couverte par les frais.",
      },
    },
    paused: {
      badge_paused: 'En pause',
      badge_scheduled: 'Pause programmée',
      resume_button: "Reprendre l'abonnement",
      cancel_scheduled_pause_button: 'Annuler la pause programmée',
    },
    pause_offer: {
      hero_amount: '0 $',
      hero_caption: 'facturé pendant la pause',
      title: "Faites une pause — n'annulez pas",
      description: 'La pause commence à la fin de votre période en cours. Vous pouvez reprendre votre abonnement quand vous le souhaitez, ou il reprendra automatiquement après 1 mois.',
      benefits: {
        no_extra_charges: 'Aucuns frais supplémentaires',
        downloads_licensed: 'Les téléchargements restent sous licence',
        resume_anytime: 'Reprenez à tout moment',
      },
      pause_button: 'Mettre mon abonnement en pause',
      continue_to_cancel: "Continuer vers l'annulation",
    },
    pause_confirmation: {
      header: 'Pause programmée',
      title: 'Votre abonnement sera mis en pause',
      description: "Vous terminerez la période déjà payée, puis l'abonnement sera mis en pause le {{date}}. Aucune facturation pendant la pause. Reprenez à tout moment — ou il reprendra automatiquement après 1 mois.",
      description_no_date: 'Vous terminerez la période déjà payée, puis votre abonnement sera mis en pause. Aucune facturation pendant la pause. Reprenez à tout moment — ou il reprendra automatiquement après 1 mois.',
      done_button: 'Terminé',
    },
    pause: {
      errors: {
        generic: "Une erreur s'est produite. Actualisez la page et réessayez.",
        subscription_not_found: "Nous n'avons pas trouvé cet abonnement. Actualisez la page.",
        subscription_cannot_be_paused: 'Cet abonnement ne peut pas être mis en pause pour le moment. Actualisez la page.',
        subscription_pause_already_scheduled: 'Une pause est déjà programmée pour cet abonnement. Actualisez la page.',
        subscription_billing_period_unavailable: "Nous n'avons pas pu programmer la pause. Réessayez plus tard ou contactez le support.",
        subscription_pause_start_must_be_future: 'Votre renouvellement est en cours de traitement. Réessayez une fois terminé.',
        user_pause_allowance_exhausted: 'Vous avez déjà utilisé la durée de pause maximale pour cet abonnement.',
        subscription_cannot_be_resumed: 'Cet abonnement ne peut pas être repris. Actualisez la page.',
        solidgate_request_failed: 'Une erreur est survenue chez notre prestataire de paiement. Actualisez la page et réessayez.',
      },
    },
    billing_cycle: {
      yearly: 'Annuel',
      monthly: 'Mensuel',
    },
    switch_plan_section: {
      price_unit: '/mois',
      tags: {
        yearly: 'ÉCONOMISEZ 60%',
        monthly: 'ANNULEZ À TOUT MOMENT',
      },
    },
    switch_plan_modal: {
      title: 'Changer de plan',
      cancel: 'Annuler',
      current_plan: 'Plan actuel',
      submit: {
        to_yearly: 'Passer au Plan Annuel',
        to_monthly: 'Passer au Plan Mensuel',
      },
      notice: {
        yearly_to_monthly: "Votre plan passera à Mensuel à la fin de votre engagement annuel actuel le {{date}}. Aucune action n'est nécessaire d'ici là.",
        monthly_to_yearly: "Votre plan passera immédiatement à Annuel. Un nouvel engagement de 12 mois commence aujourd'hui. Des frais d'annulation anticipée s'appliquent après la première facturation.",
      },
      plan: {
        yearly: {
          name: 'Plan Annuel',
          subtitle: 'facturé mensuellement',
        },
        monthly: {
          name: 'Plan Mensuel',
          subtitle: 'sans engagement',
        },
      },
      toast: {
        success: 'Votre changement de plan a été programmé.',
        error: "Nous n'avons pas pu programmer votre changement de plan. Veuillez réessayer.",
      },
      preview_toast_error: "Nous n'avons pas pu charger les détails du plan. Veuillez réessayer.",
    },
    scheduled_switch_banner: {
      title: 'Changement de plan planifié',
      description_prefix: 'Vous passerez au',
      description_on: 'le',
      description_suffix: '. Vous conservez vos avantages annuels et votre tarif de {{price}} jusque-là.',
      cancel_button: 'Annuler le changement planifié',
      cancel_success: 'Le changement de plan planifié a été annulé.',
      cancel_error: "Impossible d'annuler le changement de plan planifié. Veuillez réessayer.",
    },
    cancel_modal: {
      title: "Annuler l'abonnement",
      reason_label: 'Pourquoi souhaitez-vous annuler ?',
      reason_placeholder: 'Sélectionnez une raison...',
      submit_button: "Annuler l'abonnement",
      reasons: {
        no_longer_need: "Je n'ai plus besoin de modèles 3D pour le moment",
        short_term_project: "J'en avais besoin uniquement pour un projet à court terme",
        not_enough_models: "Je n'ai pas trouvé suffisamment de modèles pertinents",
        not_worth_price: "L'abonnement ne valait pas le prix",
        not_used_enough: "Je ne l'ai pas assez utilisé",
        prefer_individual: "Je préfère acheter des modèles à l'unité",
        other: 'Autre',
      },
      other_label: 'Veuillez préciser',
      other_placeholder: 'Dites-nous en plus...',
      banner_description: "Votre accès restera actif jusqu'au {{date}}. Aucun frais supplémentaire ne sera prélevé après cette date.",
      loading_fee: "Chargement des détails d'annulation...",
      fee_error: "Impossible de charger les détails des frais d'annulation. Veuillez fermer et réessayer.",
      fee_title: "Frais d'annulation : {{fee}}",
      fee_description: "Votre accès restera actif jusqu'au {{date}}. Des frais d'annulation seront prélevés sur votre moyen de paiement.",
      no_fee_description: "Votre accès restera actif jusqu'au {{date}}. Aucun frais d'annulation ne sera facturé.",
      fee_title_header: 'Confirmer la résiliation anticipée',
      fee_warning_banner: 'La résiliation entraînera des <strong>frais de 50 %</strong>.',
      consequences_title: 'Avant de partir — voici ce qui se passe si vous annulez',
      consequences: {
        keep_access: "Vous conserverez l'accès jusqu'à la fin de la période déjà payée.",
        no_downloads: "Après l'annulation, vous ne pourrez plus télécharger de nouveaux modèles.",
        keep_license: "Les modèles que vous avez déjà téléchargés restent sous licence pour les projets complétés lorsque l'abonnement était actif.",
        fee_notice: "Les frais d'annulation ne s'appliquent pas si vous annulez dans les 45 premiers jours. Après cette période, 50 % du solde restant de votre obligation contractuelle vous seront facturés.",
        fee_notice_new_yearly: "L'annulation de votre abonnement entraînera des frais d'annulation anticipée de 50 % du solde restant du contrat. Vous conserverez l'accès pendant la période couverte par les frais.",
      },
      remaining_months: 'Mois restants',
      monthly_rate: 'Tarif mensuel',
      total_remaining: 'Total restant',
      cancellation_fee_percent: "Frais de résiliation de 50 %",
      calculated_active_period: 'Votre période active calculée',
      contract_commitment_value: "Valeur de l'engagement contractuel :",
      cancellation_fee_summary: 'Frais de résiliation (50 %) :',
      acknowledge_checkbox: "Je comprends les frais et souhaite procéder à la résiliation",
      keep_subscription_button: "Conserver l'abonnement",
      back_button: 'Retour',
      continue_button: "Continuer vers l'annulation",
      success: 'Votre abonnement a été annulé avec succès.',
      error: "Échec de l'annulation de l'abonnement. Veuillez réessayer.",
      confirmation: {
        header: 'Abonnement annulé',
        title: 'Votre abonnement a été annulé',
        body_no_fee: "Vous conserverez l'accès jusqu'au {{date}}. Ensuite, vous ne pourrez plus télécharger de nouveaux modèles, mais tout ce que vous avez déjà téléchargé reste sous licence. Aucuns frais d'annulation n'ont été facturés.",
        body_no_fee_no_date: "À la fin de votre période en cours, vous ne pourrez plus télécharger de nouveaux modèles, mais tout ce que vous avez déjà téléchargé reste sous licence. Aucuns frais d'annulation n'ont été facturés.",
        body_fee: "Vous conserverez l'accès jusqu'au {{date}}. Des frais d'annulation anticipée de 50% s'élevant à {{fee}} ont été facturés. Les modèles que vous avez déjà téléchargés restent sous licence.",
        done_button: 'Terminé',
      },
    },
    retry_payment: {
      button: 'Réessayer le paiement',
      button_loading: 'Nouvel essai...',
      helper_text: 'Vous avez déjà résolu le problème avec votre banque ? Réessayez le prélèvement sans changer votre carte.',
      processing: {
        title: 'Nouvelle tentative de paiement en cours',
        description: "Nous avons bien reçu votre demande. Le paiement peut prendre quelques minutes - nous vous enverrons un e-mail dès qu'il sera traité.",
      },
      error: {
        default: 'Le paiement a de nouveau échoué. Veuillez mettre à jour votre moyen de paiement ou réessayer plus tard.',
      },
    },
    status_banners: {
      pause_scheduled: {
        title: 'Votre abonnement sera mis en pause le {{date}}.',
        description: "L'accès reste actif jusqu'à la fin du cycle en cours. Aucune facturation pendant la pause, et vous pouvez reprendre à tout moment.",
      },
      paused: {
        title: 'Votre abonnement est en pause.',
        description: 'Aucune facturation pendant la pause. Reprenez à tout moment depuis cette page.',
        description_operational: 'Aucune facturation pendant la pause.',
      },
      resume_requested: {
        title: 'Reprise demandée',
        description: 'Nous reprenons votre abonnement — cela peut prendre un moment. Actualisez la page pour voir le statut mis à jour.',
      },
      redemption: {
        title: 'Problème de paiement \u2014 mettre à jour le moyen de paiement',
        description: 'Votre dernière tentative de paiement a échoué. Nous réessaierons automatiquement ou vous pouvez mettre à jour le moyen de paiement pour réessayer maintenant.',
      },
      suspended: {
        title: 'Votre abonnement a été suspendu',
        description: 'Suspendu le {{date}}. Veuillez',
        description_no_date: 'Veuillez',
        contact_link: 'contacter',
        description_suffix: "le support pour obtenir de l'aide.",
      },
    },
    payment_history: {
      status: {
        failed: 'Échoué',
      },
    },
  },
  subscription_item_page: {
    subscribe_cta: 'S\'abonner et économiser',
    upgrade_cta: 'Améliorer le forfait',
  },
  subscription_upgrade: {
    explainer: {
      prefix: 'Passage depuis Essentials. Vous avez utilisé',
      used_of_limit: '{{used}} sur {{limit}}',
      middle: 'téléchargements cette période, nous créditons donc les',
      unused: '{{unused}} inutilisés',
      suffix: 'sur le montant d\'aujourd\'hui.'
    },
    payment_method: {
      title: 'Moyen de paiement',
      subtitle: 'Nous utiliserons la carte enregistrée sur votre compte — pas besoin de la saisir à nouveau.',
      saved_badge: 'Enregistrée',
      use_different: 'Utiliser un autre moyen de paiement'
    },
    order_summary: {
      title: 'Récapitulatif de la commande',
      plan_name: 'Abonnement CGTrader Premium',
      plan_cadence: 'forfait annuel, facturé mensuellement',
      billing_period: '1 an à',
      premium_price: 'Sous-total Premium',
      credit_label: 'Crédit Essentials',
      credit_basis: '{{unused}} téléchargements inutilisés sur {{limit}}',
      vat_included: 'TVA (incluse)',
      vat_tooltip: 'La Taxe sur la Valeur Ajoutée (TVA), également connue sous le nom de taxe de vente ou taxe sur les produits et services (TPS), est une taxe appliquée au point de vente à l\'acheteur final et versée au gouvernement du pays de l\'acheteur.',
      amount_due_today: 'Montant dû aujourd\'hui',
      cta: 'Payer {{amount}} et mettre à niveau',
      next_billing_note: '*Prochaine facturation à {{price}}/mois',
      legal_agreement_prefix: 'En continuant, j\'accepte les',
      legal_agreement_terms: 'Conditions Générales',
      legal_agreement_privacy: 'Politique de Confidentialité',
      legal_agreement_connector: 'et la',
    }
  },
  subscription_checkout: {
    title: 'Choisissez un moyen de paiement',
    subtitle: 'Payez en toute sécurité avec Apple Pay, Google Pay, PayPal ou une carte de crédit.',
    divider_text: 'Ou',
    credit_card_button: 'Payer par carte de crédit / débit',
    terms: {
      title: 'Vous souscrivez à un abonnement annuel au service CGTrader.',
      body_start: 'Vous acceptez d\'être facturé {{price}} par mois jusqu\'à la fin du contrat ou l\'annulation de l\'abonnement. Les paiements seront prélevés via le mode de paiement que vous avez sélectionné. Pour annuler, accédez à Paramètres du compte → Gestion de l\'abonnement ou consultez notre <a href="https://www.cgtrader.com/pages/terms-and-conditions" target="_blank" class="cgt-legacy-link">Politique d\'annulation</a>. ',
      body_end: 'Veuillez noter que le plan annuel comporte des frais d\'annulation anticipée.',
      annual: {
        title: 'Conditions de l\'abonnement annuel (facturation mensuelle)',
        body: 'Vous souscrivez à un abonnement annuel à CGTrader. Vous acceptez d\'être facturé {{price}}/mois plus les taxes applicables jusqu\'à la fin du contrat ou l\'annulation. Vous pouvez annuler à tout moment. Si vous annulez dans les 45 premiers jours, aucuns frais d\'annulation anticipée ne s\'appliquent. Passé ce délai, des frais peuvent s\'appliquer. Pour annuler, accédez à Paramètres du compte → Gestion de l\'abonnement ou consultez notre <a href="https://www.cgtrader.com/pages/terms-and-conditions" target="_blank" rel="noreferrer" class="cgt-legacy-link">Politique d\'annulation</a>.',
      },
      monthly: {
        title: 'Conditions de l\'abonnement mensuel',
        body: 'Vous souscrivez à un abonnement mensuel à CGTrader. Vous acceptez d\'être facturé {{price}}/mois. Annulez à tout moment depuis Paramètres du compte → Gestion de l\'abonnement, sans frais.',
      },
    },
    plan_selector: {
      section_title: 'Choisir un plan',
      names: {
        yearly: 'Plan annuel',
        monthly:        'Plan mensuel',
      },
      subtitles: {
        billed_monthly: 'facturation mensuelle',
        no_commitment: 'sans engagement',
      },
      badges: {
        save_60:        'Économisez 60 %',
        cancel_anytime: 'Annulable à tout moment',
      },
      select_aria: 'Sélectionner le {{name}}',
    },
    update_title: 'Mettre à jour le moyen de paiement',
    update_subtitle: 'Mettez à jour vos informations de paiement en toute sécurité.',
    update_credit_card_button: 'Carte de crédit / débit',
    update_save_button: 'Enregistrer',
    update_cancel_button: 'Annuler',
    order_summary: {
      title: 'Récapitulatif de la commande',
      item_context: {
        sub_label: 'Disponible au téléchargement après l\'abonnement',
      },
      billing_period: '1 an à',
      price_unit: '/mois',
      subtotal: 'Sous-total',
      vat_included: 'TVA',
      vat_tooltip: 'La Taxe sur la Valeur Ajoutée (TVA), également connue sous le nom de taxe de vente ou taxe sur les produits et services (TPS), est une taxe appliquée au point de vente à l\'acheteur final et versée au gouvernement du pays de l\'acheteur.',
      amount_due_today: 'Total de la commande',
      pay_button: 'S\'abonner pour {{amount}}',
      pay_button_upgrade: 'Payer {{amount}} et mettre à niveau',
      premium_renewal_note: 'Premium est débloqué immédiatement – puis {{price}}/mois à partir du {{date}}',
      legal_agreement_prefix: 'En continuant, j\'accepte les',
      legal_agreement_terms: 'Conditions Générales',
      legal_agreement_privacy: 'Politique de Confidentialité',
      legal_agreement_connector: 'et la',
      plans: {
        yearly: {
          name:           'Abonnement CGTrader Essentials — plan annuel, facturé mensuellement',
          billing_period: '1 an à',
          price_unit:     '/mois',
          features: {
            first:  '25 ressources / mois — téléchargez des modèles ou générez avec l\'IA',
            second: 'Accès instantané à plus de {{modelCount}} modèles 3D essentiels',
            third:  'Libre de droits, sans IA',
          },
        },
        monthly: {
          name:           'CGTrader Essentials — plan mensuel',
          billing_period: '',
          price_unit:     '/mois',
          features: {
            first:  '25 ressources / mois — téléchargez des modèles ou générez avec l\'IA',
            second: 'Accès instantané à plus de {{modelCount}} modèles 3D essentiels',
            third:  'Libre de droits, sans IA',
          },
        },
      },
    },
    company: {
      toggle_label: 'Purchase as a company',
      info_banner: 'Make sure you filled and applied company details.',
      company_name: 'Company name',
      company_code: 'Company code',
      vatin: 'Company tax number',
      vatin_tooltip: 'If your company is registered for VAT/GST/Sales or equivalent tax, please make sure to enter your tax number for validation (in some cases you might be eligible for 0% tax rate).',
      country: 'Country',
      state: 'State / Province',
      zip_code: 'Zip code',
      city: 'City',
      street_address: 'Street address',
      apply_button: 'Apply',
      applying: 'Applying...',
      field_required: 'Ce champ est obligatoire',
    },
    payment_success_processing: 'Traitement du paiement. Veuillez patienter…',
    payment_retry_button: 'Réessayer',
    payment_success_toast: 'Les informations de paiement ont été enregistrées avec succès.',
    payment_error_toast: 'Le paiement a échoué. Veuillez réessayer.',
    email_step: {
      title: 'Entrez votre e-mail',
      subtitle: 'pour continuer avec l\'abonnement',
      email_label: 'Adresse e-mail',
      email_placeholder: 'john@email.com',
      email_required: 'L\'e-mail est requis',
      email_invalid: 'Veuillez entrer une adresse e-mail valide',
      helper_text: 'Il ne sera utilisé que pour vous envoyer des informations transactionnelles.',
      continue_button: 'Continuer',
      login_link_prefix: 'Vous avez déjà un compte ?',
      login_link: 'Se connecter',
      divider: 'ou',
    },
    captcha_step: {
      title: 'Vérification de sécurité rapide',
      subtitle: 'Veuillez compléter la vérification ci-dessous pour continuer vers le paiement.',
      continue_button: 'Continuer',
      incomplete: 'Veuillez compléter le captcha pour continuer.',
      failed: 'La vérification du captcha a échoué. Veuillez réessayer.',
    },
    login_step: {
      info_title: 'Il semble que vous ayez déjà un compte',
      info_subtitle: 'Connectez-vous pour continuer',
      title: 'Content de vous revoir',
      subtitle: 'Connectez-vous pour compléter votre abonnement',
      email_label: 'E-mail',
      password_label: 'Mot de passe',
      login_button: 'Se connecter et continuer',
      forgot_password: 'Mot de passe oublié ?',
      hide_password: 'Masquer le mot de passe',
      show_password: 'Afficher le mot de passe',
    },
    guest_banner: {
      paying_as: 'Paiement en tant que',
      not_you: 'Ce n\'est pas vous ?',
    },
    create_account: {
      notice_title: 'Payment successful - you are subscribed!',
      notice_body: 'Your {{plan}} subscription is now active. A confirmation has been sent to',
      notice_body_no_plan: 'Your subscription is now active. A confirmation has been sent to',
      title: 'One last step - create your account',
      subtitle: 'Set a password to log in, download your model, and manage your subscription.',
      email_label: 'Email',
      submit_button: 'Register and start downloading',
    },
  },
  my_subscriptions: {
    profile_header: {
      title: 'Paramètres d\'abonnement',
      description: 'Gérez votre participation au programme Essentials.',
      learn_more: 'En savoir plus',
    },
    status_card: {
      title: 'CGTrader Essentials',
      badge_participating: 'Participant',
      badge_not_participating: 'Non participant',
      description: 'Le programme d\'abonnement Essentials permet aux utilisateurs d\'accéder à une bibliothèque de modèles sélectionnés moyennant un abonnement mensuel.',
      participation_label: 'Participation :',
      participation_text: 'Tous les modèles éligibles seront inclus. Les modèles ne peuvent pas être sélectionnés individuellement.',
      revenue_share_label: 'Partage des revenus :',
      revenue_share_text: 'Les revenus sont calculés en fonction de votre part des téléchargements totaux d\'abonnement du pool de revenus mensuel.',
      manage_label: 'Gérez votre participation à tout moment :',
      manage_text: 'Les modifications prennent effet peu après la mise à jour de vos paramètres.',
      join_title: 'CGTrader Essentials est inclus dans le programme Maximisez vos Revenus.',
      join_description: 'Accédez aux revenus d\'abonnement, au partage des revenus et aux opportunités entreprise personnalisées.',
      join_button: 'Rejoindre le programme Maximiser mes revenus',
    },
    tabs: {
      eligible_models: 'Modèles éligibles',
      earnings: 'Revenus',
    },
    eligible_models: {
      description_line1: 'Consultez tous vos modèles éligibles pour générer des revenus d\'abonnement.',
      description_line2: 'Vos modèles restent actifs et disponibles pour les abonnés jusqu\'à ce que vous choisissiez de vous désinscrire.',
      column_models: 'Modèles',
      column_publishing_date: 'Date de publication',
      column_opt_in_date: 'Date d\'inscription',
      empty_title: 'Aucun modèle disponible',
      empty_description: 'Vous n\'avez aucun modèle éligible pour CGTrader Essentials pour le moment.',
    },
    join_modal: {
      title: 'Abonnements CGTrader',
      title_legacy: 'Rejoindre le programme Maximisez vos revenus',
      participating_pill: 'Participation au programme Maximisez vos revenus',
      intro_heading: 'Activez Maximisez vos revenus pour commencer',
      intro_body: 'Débloquez des opportunités de monétisation supplémentaires conçues pour augmenter vos revenus à long terme. Ce programme vous donne accès à :',
      intro_programs_essentials_label: 'CGTrader Essentials et Premium',
      intro_programs_essentials_text: '— Gagnez grâce aux téléchargements mensuels par abonnement',
      intro_programs_enterprise_label: 'Accords entreprise et sur mesure',
      intro_programs_enterprise_text: 'Participez à des accords B2B personnalisés',
      intro_programs_revenue_label: 'Opportunités de partage des revenus',
      intro_programs_revenue_text: 'Bénéficiez de partenariats stratégiques de distribution',
      intro_programs_equity_label: 'Collaborations basées sur l\'équité',
      intro_programs_equity_text: 'Échangez des modèles sélectionnés contre une participation au capital',
      intro_programs_other_label: 'Autres modèles alternatifs de rémunération',
      intro_programs_other_text: 'à mesure qu\'ils deviennent disponibles',
      intro_inset_title: 'Ce qui se passe lorsque vous rejoignez',
      intro_inset_models: 'Vos modèles éligibles intègrent le pool du programme',
      intro_inset_earnings: 'Vous accédez aux revenus basés sur l\'abonnement',
      intro_inset_opportunities: 'Vous pourrez être considéré pour des opportunités entreprise et de rémunération alternative',
      section_what_title: 'Comment fonctionnent les abonnements',
      section_what_body: 'CGTrader propose deux formules d\'abonnement aux acheteurs :',
      section_what_tier_essentials_label: 'Essentials',
      section_what_tier_essentials_text: '— 9,99 $/mois, 25 téléchargements. Ressources du quotidien.',
      section_what_tier_premium_label: 'Premium',
      section_what_tier_premium_text: '— 34,99 $/mois, 25 téléchargements. Ressources haut de gamme.',
      section_what_tiers_note: 'Vos modèles sont inclus dans la formule qui correspond à leur catégorie. Un modèle peut apparaître dans une seule ou dans les deux formules. Les téléchargements non utilisés ne sont pas reportés.',
      section_earnings_title: 'Comment vos revenus sont calculés',
      section_earnings_body: 'Chaque mois, CGTrader alloue une part des revenus d\'abonnement proportionnelle au nombre de fois que vos modèles ont été téléchargés par rapport à tous les téléchargements par abonnement de ce mois.',
      section_earnings_rule: 'Une règle s\'applique : chaque téléchargement vous rapporte jusqu\'au prix listé de votre modèle multiplié par votre taux de redevance - si votre modèle est au prix de 5 $, vous gagnez un maximum de 5 $ multiplié par votre taux de redevance par téléchargement.',
      section_earnings_timing: 'Les revenus sont calculés le 1er du mois suivant et ne sont jamais ajustés rétroactivement.',
      section_refunds_title: 'Remboursements et rétrofacturations',
      section_refunds_body: 'Si un abonné est remboursé, ce paiement est retiré du pool de revenus dans le mois où le remboursement a lieu, et non dans le mois du téléchargement initial. En pratique, les remboursements sont rares et n\'affecteront pas significativement vos revenus.',
      section_optin_title: 'Activer et désactiver',
      section_optin_body: 'Les modèles sont ajoutés au catalogue d\'abonnement lorsque Maximisez vos revenus est activé (Mes ventes → Remises). Pour retirer vos modèles, désactivez le paramètre. Les revenus passés ne sont pas affectés.',
      join_cta: 'Rejoindre Maximisez vos revenus',
      description: 'Débloquez des opportunités de monétisation supplémentaires conçues pour augmenter vos revenus à long terme. Ce programme vous donne accès à :',
      benefit_essentials_label: 'CGTrader Essentials',
      benefit_essentials_text: '– Gagnez grâce aux téléchargements d\'abonnement mensuels',
      benefit_enterprise_label: 'Offres entreprise et personnalisées',
      benefit_enterprise_text: '– Participez à des accords B2B sur mesure',
      benefit_revenue_label: 'Opportunités de partage des revenus',
      benefit_revenue_text: '– Bénéficiez de partenariats de distribution stratégiques',
      benefit_equity_label: 'Collaborations basées sur l\'équité',
      benefit_equity_text: '– Échangez des modèles sélectionnés contre une participation au capital',
      benefit_other_label: 'Autres modèles de rémunération alternative',
      benefit_other_text: 'dès qu\'ils sont disponibles',
      info_box_title: 'Ce qui se passe lorsque vous rejoignez :',
      info_box_essentials_name: 'CGTrader Essentials',
      info_box_essentials_suffix: 'est entièrement inclus dans ce programme :',
      info_box_models: 'Vos modèles éligibles intègrent le pool du programme',
      info_box_earnings: 'Vous accédez aux revenus basés sur l\'abonnement',
      info_box_enterprise: 'Vous pouvez être considéré pour des opportunités entreprise et de rémunération alternative',
      confirm_button: 'Rejoindre le programme',
      cancel_button: 'Annuler',
      got_it_button: 'Compris',
      success: 'Vous avez rejoint avec succès le programme Maximisez vos revenus',
      error: 'Une erreur s\'est produite. Veuillez réessayer.',
    },
  },
  publisher: {
    tooltips: {
      tags:
        'Les 4 à 6 premiers tags sont les plus importants pour la recherche. Décrivez d\'abord l\'objet principal, puis ajoutez les détails.',
      adult_content:
      'Tous les modèles contenant de la nudité ou de la violence sont examinés par CGTrader avant leur publication, sous 1–3 jours ouvrés. CGTrader utilise les standards RSAC pour évaluer le contenu. Le contenu de niveau 0 est accessible à tout le monde. Les modèles classés niveau 1-2 peuvent être publiés avec une restriction d’âge. Les modèles classés niveau 3-4 ne sont pas autorisés à la publication sur la place de marché.',
    },
  },
  skills:{
    '3d-modeling': '3D Modeling',
    '3d-print-modeling': '3D Print Modeling',
    '3d-scanning': '3D Scanning',
    'animating': 'Animating',
    'grooming': 'Grooming',
    'lighting': 'Lighting',
    'low-poly-modeling': 'Low-poly Modeling',
    'particles': 'Particles',
    'pbr-modeling': 'PBR Modeling',
    'post-production': 'Post Production',
    'rendering': 'Rendering',
    'rigging': 'Rigging',
    'shaders': 'Shaders',
    'skinning': 'Skinning',
    'texturing': 'Texturing',
    'uv-mapping': 'UV mapping'
  },
  profilePage: {
    listings: 'Modèles 3D',
    reviews: 'Avis',
    imageGallery: 'Galerie d’images',
    tutorials: 'Tutoriels',
    rating: 'Évaluation',
    reputation: 'Réputation',
    responseRate: 'Taux de réponse',
    responseTime: 'Délai de réponse',
    projectsDone: 'Projets 3D réalisés',
    modelViews: 'Vues du modèle',
    modelLikes: 'Aimes du modèle',
    followers: 'Suiveurs',
    software: 'Logiciels 3D',
    skill: 'Compétences',
    about: 'À propos',
    modelos: 'Modèles 3D',
    projects: 'Projets 3D',
    reviewsGiven: 'Avis donnés',
    ratings: 'Notes',
    positive: 'Positif',
    negative: 'Négatif',
    priceLabel: 'Prix',
    positiveFirst: 'Positifs en premier',
    negativeFirst: 'Négatifs en premier',
    tooltipTextResponseRate: 'Pourcentage des messages reçus auxquels l’utilisateur a répondu',
    tooltipTextResponseTime: 'Temps moyen de réponse de l’utilisateur',
    tooltipTextProjectsDone: 'Nombre de projets 3D terminés avec succès. Actuellement en cours sur {{projectCount}} projets 3D',
    tooltipTextModelViews: 'Nombre de fois que les modèles du designer ont été vus',
    tooltipTextModelLikes: 'Nombre de likes que les modèles du designer ont reçus',
    tooltipTextFollowers: 'Nombre d’abonnés que le designer a',
    noModelsUploaded: 'L’utilisateur n’a pas encore téléversé de modèles 3D.',
    noModelsReviews: 'Aucun avis sur les modèles 3D pour le moment.',
    noProjectsReviews: 'Aucun avis sur les projets 3D pour le moment.',
    loadMore: 'Charger plus',
    noArtworksUploaded: 'L’utilisateur n’a pas encore téléversé d’œuvres d’art.',
    noTutorialsUploaded: 'L’utilisateur n’a pas encore publié de tutoriels.',
    seeAllModels: 'Voir les {{modelCount}} modèles 3D',
    viewAllModels: 'Voir les {{modelCount}} modèles'
  },
  "navigation": {
    "aria": {
      "open_menu": "Ouvrir le menu",
      "close_menu": "Fermer le menu",
      "search": "Rechercher",
      "search_by_image": "Recherche par image",
      "cart": "Panier",
      "messages": "Messages",
      "notifications": "Notifications",
      "account": "Compte",
      "logo": "CGTrader - Modèles 3D / Concepteurs 3D",
    },
    "navbar": {
      "actions": {
        "new": "Nouveau",
        "trending": "Tendances",
        "top_selling": "Meilleures ventes",
      },
      "budgets": {
        "below_10": "Moins de 10$",
        "up_to_10": "Jusqu'à 10$",
        "more_than_20": "Plus de 20$",
        "more_than_50": "Plus de 50$",
        "free": "Gratuit",
        "sale": "En vente",
      },
      "3d_models": {
        "categories": "Catégories",
        "types": "Type",
        "budget": "Budget",
        "all_models": "Tous les modèles",
        "browse_all": "Tous les modèles 3D",
        "browse_all_print": "Tous les modèles d'impression 3D",
        "about": "À propos des modèles 3D",
        "about_print": "À propos de l'impression 3D",
      },
      "community": {
        "title": "Communauté",
        "earn": "Gagnez",
        "upload_3d_model": "Téléverser un modèle 3D",
        "search_for_projects": "Rechercher des projets",
      },
      "grow_your_sales": {
        "title": "Augmentez vos Ventes",
        "sell_more": "Vendez Plus 🚀",
        "3d_market_insights": "Aperçus du Marché 3D",
        "top_model_searches": "Recherches Populaires de Modèles 3D",
        "top_print_searches": "Recherches Populaires d'Impression 3D",
      },
    },
    "search": {
      "placeholder": "Rechercher dans plus de 2 millions de modèles",
    },
    "user": {
      "login": "Connexion",
      "register": "S'inscrire",
    },
    "projects": {
      "seller_perspective": "Projets 3D en free-lance",
      "browse": "Explorez les projets ",
      "start": "Démarrez un projet",
      "about": "A propos des projets 3D",
      "work": "Travaillez avec CGTrader",
      "my_projects": "Mes projets",
      "buyer_perspective": "Recruter des concepteurs 3D"
    },
    "3d-models": {
      "title": "Modèles 3D",
      "3d-printing": "Modèles d'impression 3D",
      "pbr": "Modèles 3D PBR",
      "vr_low-poly": "Modèles 3D low-poly",
      "scanned_3d-models": "Modèles 3D scannés",
      "find_designers": "Trouvez les meilleurs concepteurs",
      "discounts": "Remises",
      "scripts_apps": "Scripts & applications",
      "textures": "Textures CG",
      "show-all": "Afficher tout",
      "free": "Modèles 3D gratuits"
    },
    "sell_3d-models": "Vendre des modèles 3D",
    "enterprise": {
      "title": "Production de contenu 3D",
      "management": "Gestion des ressources 3D"
    },
    "credits_guest_widget": {
      "get": " et obtenez jusqu'à ",
      "create": "Créez un compte maintenant!",
      "learn_more": "En savoir plus sur les crédits de fidélité de CGTrader",
      "link": "ici",
      "text_below_1": "Les crédits peuvent être utilisés lors de l'achat \"",
      "text_below_2": "\" validez les modèles marqués et obtenez jusqu'à 30% de réduction du prix.",
      "sign-up": "S'inscrire",
      "discount": " remise",
      "for": " pour votre ",
      "purchase": "Premier achat !"
    },
    "tooltips": {
      "discounts": " rabais de fidélité de CG Trader",
      "cart": "Panier",
      "conversations": "Mes conversations",
      "notifications": "notifications",
      "publisher": "Éditeur"
    },
    "cart_widget": {
      "wishlist_tab": "Liste de souhaits",
      "recently_viewed_tab": "Récemment consultés",
      "potential_discount": "Remise potentielle :",
      "discount_applied": "Remises appliquées :",
      "sale_tooltip": "Les remises de nos campagnes de soldes ne s'appliquent que lorsque votre panier atteint ${{threshold}} ou plus.",
      "left_to_unlock_discounts": "Encore {{leftToUnlock}} pour débloquer les remises",
      "continue_shopping": "Continuer les achats",
      "wishlist_empty_title": "Votre liste de souhaits est vide",
      "wishlist_empty_text": "Commencez à explorer et enregistrez vos favoris pour plus tard — ils apparaîtront ici.",
      "recently_viewed_empty_title": "Rien ici pour l'instant",
      "recently_viewed_empty_text": "Commencez à explorer et vos articles récemment consultés apparaîtront ici.",
      "sale_tooltip_text": "Cet article est en promotion, mais la réduction ne sera appliquée que lorsque le sous-total de votre panier atteindra ${{threshold}} ou plus.",
      "title": "Panier",
      "subtitle": "Le Panier est Vide",
      "text": "Commencez à explorer et remplissez votre panier de trouvailles formidables!",
      "have": "Vous avez",
      "items": " articles dans votre panier.",
      "total": "Total: ",
      "remainer": "Pour activer les points de CGTrader, ajoutez: ",
      "used": "Crédits utilisés: ",
      "discount": "Remise avec coupon de l'entreprise: ",
      "sale_discounts": "Remises appliquées: ",
      "sale_time_left": "La vente se termine dans",
      "final": "Prix ​​final: ",
      "proceed": "Procédez au paiement",
      "view": " Voir le panier"
    },
    "community": {
      "title": "Communauté",
      "galleries": "Galeries",
      "tutorials": "Tutoriels",
      "forum": "Forum",
      "designers": "Les concepteurs",
      "challenges": "Défis",
      "digital_art": "Concours d'art numérique ",
      "blog": "Blog",
      "community_ratings": "Évaluations de la communauté",
      "sell_3d-models": "Vendre des modèles 3D",
      "printlist": "Liste d'impression 3D",
      "invite": "Invitez un ami"
    },
    "credits_user_widget": {
      "title": " rabais de fidélité de CG Trader",
      "par_1": "Vous avez",
      "par_2": " crédits CGTrader.",
      "par_2_variation": " en Points que vous pouvez dépenser lorsqu'aucune promotion n'est disponible.",
      "notice": "REMARQUE: Les points CGTrader ne peuvent pas être utilisés pendant la vente en cours, mais ils seront à nouveau disponibles une fois la vente terminée. En attendant, découvrez d'excellentes offres sur les modèles 3D <a href=\"https://www.cgtrader.com/3d-models?sale_off=1\">ici</a>.",
      "first_text_1": "Considérez-le un cadeau pour votre premier achat - vous pouvez utiliser des crédits lors d'achats \"",
      "first_text_2": " \" validez les modèles marqués et obtenez jusqu'à 30% de réduction du prix. Les crédits ne peuvent être utilisés que si la valeur totale de votre panier est égal ou supérieur à",
      "regular_text_1": "Les crédits peuvent être utilisés lors d'achats \"",
      "regular_text_2": " \" validez les modèles marqués et obtenez jusqu'à 30% de réduction du prix.",
      "important": "IMPORTANT:",
      "message": " Les crédits ne peuvent être utilisés lors des campagnes de vente, mais vous pouvez toujours augmenter votre niveau de royalties et recueillir plus de crédits pour votre prochain achat.",
      "more_credits": "Comment puis-je obtenir plus de crédits?",
      "list_item": "En augmentant vos dépenses de toute une vie sur CGTrader, votre taux d'obtention de crédit augmente également.",
      "learn_more": "En savoir plus",
      "earn_rate": "Taux d'obtenrion de crédit ",
      "lifetime_spending": "Les dépenses de toute une vie: ",
      "next_level": "Niveau suivant: ",
      "condition_1": 'Les points CGTrader peuvent être utilisés pour l\'achat de modèles marqués du signe <i class="custom-font-icon custom-font-icon--small icon-wallet"></i>, offrant jusqu\'à 30% de réduction sur leur prix.',
      "condition_2": 'Les points ne peuvent être utilisés que si la valeur totale de votre panier est de <strong>${{minimum}}</strong> ou plus.',
      "condition_3": "Pendant les ventes ou promotions actives, les points ne peuvent pas être utilisés.",
      "condition_4": 'Gardez à l\'esprit que les points ont une date d\'expiration - vos points expireront dans <strong>{{days}}</strong> jours.',

    },
    "item_add_message": "a été ajouté avec succès au panier",
    "already_added_message": "a déjà été ajouté au panier",
    "conversations_widget": {
      "messages": {
        "loading": "boîte de réception de chargement"
      },
      "conversations": "conversations",
      "types": {
        "personal": "Message personnel",
        "offer": "Offre de prix",
        "cgtrader_support": "Assistance CGTrader ",
        "model_support": "Modèle de support",
        "job_application": "projet 3D",
        "file_conversion_request": "demande de conversion de fichier",
        "model_feedback": "Commentaires sur le produit",
        "promotions": "promotions"
      }
    },
    "user_menu": {
      "gdpr_notice": {
        "message": "Vous devez vérifier vos {{link}}",
        "link": "préférences de notifications par e-mail"
      },
      "dashboard": "Tableau de bord admin",
      "settings": "Paramètres du compte",
      "public_profile": "Profil public",
      "logout": "Se déconnecter",
      "seller": {
        "publishing": "Télécharger un modèle 3D",
        "models": "Mes modèles",
        "sales": "Mes ventes",
        "subscription": "Abonnement",
        "analytics": "Analytiques",
        "freelance": "Mes Projets 3D",
        "wishlist": " Liste de souhait de modèles 3D",
        "freelance_cgtrader": "Travailler en freelance avec CGTrader",
        "publish_project": "Publier un projet",
        "find_new_projects": "Trouver de nouveaux projets 3D"
      },
      "buyer": {
        "purchases": "Mes achats",
        "wishlist": " Liste de souhait de modèles 3D",
        "freelancers": "Trouvez des freelance ",
        "sell": "Vendre des modèles 3D"
      }
    },
    "already_purchased_message": "Vous avez déjà acheté cet article.",
    "cart_limit_reached": "Vous avez atteint la limite de 500 articles dans votre panier. Pour continuer vos achats, veuillez compléter votre commande actuelle et en commencer une nouvelle pour tout article supplémentaire."
  },
  'sale_off_bar': {
    'find_deals': 'Trouver des offres',
  },
  'subscribe_bar': {
    'content_full': '25 modèles par mois, à partir de {{price}}',
    'content_short': '25 modèles par mois, à partir de {{price}}',
    'cta': 'S\'abonner',
  },
  'cgdream_notice_bar': {
    'message': 'Vous venez de CGDream ? La génération d\'images se trouve désormais ici, sur CGTrader AI.',
    'dismiss': 'Fermer l\'avis',
  },
  "footer": {
    "subscribe": {
      "header": "Abonnez-vous à nos nouvelles:",
      "button-active": "Souscrire",
      "button-disabled": "Inscrit",
      "text": "En vous abonnant confirmez que vous avez lu et accepté notre",
      "terms-link": "Conditions d'utilisation",
      "placeholder": "Entrer votre Email"
    },
    "links": {
      companyLinks: [
        {
          text: 'Entreprise',
          link: '/discover/about-us',
        },
        {
          text: 'Blog',
          link: '/blog',
        },
        {
          text: 'Carrières',
          link: '/pages/careers',
        },
        {
          text: 'Centre d\'aide',
          link: 'https://help.cgtrader.com',
        },
      ],
      buyLinks: [
        {
          text: 'Acheter des modèles 3D',
          link: '/fr/3d-modeles',
        },
        {
          text: 'Pour les entreprises',
          link: '/discover/business-account',
        },
        {
          text: 'Jeux de données 3D',
          link: '/discover/datasets',
        },
        {
          text: 'Engager un designer 3D',
          link: '/3d-modeling-jobs',
        },
        {
          text: 'Modèles 3D gratuits',
          link: '/fr/libre-3d-modeles',
        },
        {
          text: 'Modèles 3D à imprimer gratuits',
          link: '/fr/libre-3d-imprimer-modeles',
        },
      ],
      sellLinks: [
        {
          text: 'Vendre des modèles 3D',
          link: '/discover/sell-3d-models',
        },
        {
          text: 'Augmentez vos ventes',
          link: '/discover/sell-more',
        },
        {
          text: 'Aperçus du marché 3D',
          link: '/discover/3d-market-trends',
        },
        {
          text: 'Principales recherches de modèles 3D',
          link: '/discover/3d-models-top-searches',
        },
        {
          text: 'Principales recherches de modèles 3D imprimés',
          link: '/discover/3d-print-models-top-searches',
        },
      ],
      communityLinks: [
        {
          text: 'Communauté',
          link: '',
        },
        {
          text: 'Top designers',
          link: '/designers',
        },
        {
          text: 'Défis',
          link: '/challenges',
        },
        {
          text: 'Forum',
          link: '/forum',
        },
      ],
      // "enterpriseLinks": [
      //   {
      //     "text": "Modelry",
      //     "link": "https://www.modelry.ai/?utm_source=cgtrader_marketplace&utm_medium=referral&utm_campaign=marketplace_shop&utm_id=00001&utm_term=2210&utm_content=modelry&utm_creative_format=footer_menu&utm_marketing_tactic=marketplace_users&utm_source_platform=cgtrader"
      //   },
      //   {
      //     "text": "Visionneuse 3D",
      //     "link": "https://www.modelry.ai/3d-viewer?utm_source=cgtrader_marketplace&utm_medium=referral&utm_campaign=marketplace_shop&utm_id=00001&utm_term=2210&utm_content=3d_viewer&utm_creative_format=footer_menu&utm_marketing_tactic=marketplace_users&utm_source_platform=cgtrader"
      //   },
      //   {
      //     "text": "Visualisation de produit en 3D",
      //     "link": "https://www.modelry.ai/3d-product-visualization?utm_source=cgtrader_marketplace&utm_medium=referral&utm_campaign=marketplace_shop&utm_id=00001&utm_term=2210&utm_content=3d_product_visualization&utm_creative_format=footer_menu&utm_marketing_tactic=marketplace_users&utm_source_platform=cgtrader"
      //   },
      //   {
      //     "text": "Gestion des actifs numériques 3D",
      //     "link": "https://www.modelry.ai/3d-digital-asset-management?utm_source=cgtrader_marketplace&utm_medium=referral&utm_campaign=marketplace_shop&utm_id=00001&utm_term=2210&utm_content=3d_digital_asset_management&utm_creative_format=footer_menu&utm_marketing_tactic=marketplace_users&utm_source_platform=cgtrader"
      //   },
      //   {
      //     "text": "Modélisation 3D sur mesure",
      //     "link": "https://www.modelry.ai/how-to-order-custom-3d-models?utm_source=cgtrader_marketplace&utm_medium=referral&utm_campaign=marketplace_shop&utm_id=00001&utm_term=2210&utm_content=3d_content_production&utm_creative_format=footer_menu&utm_marketing_tactic=marketplace_users&utm_source_platform=cgtrader"
      //   },
      //   {
      //     "text": "Photographie virtuelle",
      //     "link": "https://www.modelry.ai/virtual-photography?utm_source=cgtrader_marketplace&utm_medium=referral&utm_campaign=marketplace_shop&utm_id=00001&utm_term=2210&utm_content=virtual_photography&utm_creative_format=footer_menu&utm_marketing_tactic=marketplace_users&utm_source_platform=cgtrader"
      //   }
      // ],
      // aiImageGeneratorLinks: [
      //   {
      //     text: 'CGDream | Générateur d\'Images IA',
      //     link: 'https://cgdream.ai/',
      //   },
      //   {
      //     text: 'Générer des Images avec Flux Dev',
      //     link: 'https://cgdream.ai/features/free-flux-ai-image-generator',
      //   },
      //   {
      //     text: 'IA Texte vers Image',
      //     link: 'https://cgdream.ai/features/text-to-image-ai-generator',
      //   },
      //   {
      //     text: 'Éditeur de Photos IA',
      //     link: 'https://cgdream.ai/features/ai-photo-editor',
      //   },
      //   {
      //     text: 'Rendu 3D par IA',
      //     link: 'https://cgdream.ai/features/ai-3d-rendering',
      //   },
      //   {
      //     text: 'Générateur de Modèles 3D IA',
      //     link: 'https://cgdream.ai/features/ai-3d-model-generator-image-to-3d',
      //   },
      //   {
      //     text: 'Filtres IA pour Images',
      //     link: 'https://cgdream.ai/features/ai-filters-for-images',
      //   },
      //   {
      //     text: 'Agrandisseur d\'Images IA',
      //     link: 'https://cgdream.ai/features/ai-image-upscaler',
      //   },
      //   {
      //     text: 'Retouche d\'Image IA',
      //     link: 'https://cgdream.ai/features/ai-image-inpainting',
      //   },
      // ],
    },
    "bottom-row": {
      "terms-link": "Termes et conditions",
      "privacy": "Confidentialité"
    }
  },
  "profile": {
    "model_uploader": {
      "file_not_finalized_tooltip": "Ce fichier n'a pas terminé son téléversement et ne sera pas publié. Supprimez-le et téléversez-le à nouveau.",
      "file_not_finalized_sr": "Le fichier n'a pas terminé son téléversement et ne sera pas publié."
    },
    "my_models": {
      "pack_creation": {
        "flash_error": "Une erreur est survenue, veuillez réessayer",
        "load_error": "Impossible de charger les modèles sélectionnés. Cela peut arriver lorsque trop de modèles sont sélectionnés en même temps. Veuillez réessayer ou sélectionner moins de modèles.",
        "retry": "Réessayer"
      },
      "image_restore": {
        "body_default": "Certains aperçus de vos modèles ont peut-être été affectés par un récent problème de stockage. Si l'une de vos images semble corrompue, cliquez sur Restaurer les images et nous les vérifierons et corrigerons sur tous vos modèles.",
        "title_pending": "Nous restaurons vos aperçus",
        "body_pending": "Votre demande a bien été prise en compte : nous vérifions chaque modèle. Ce traitement s'exécute en arrière-plan et peut prendre jusqu'à 3 jours, vous n'avez donc pas besoin de garder cette page ouverte. Nous vous préviendrons ici et par e-mail une fois terminé.",
        "title_finished": "Restauration terminée",
        "body_finished": "Nous avons vérifié tous vos modèles et restauré ce que nous avons pu. Si une miniature affiche toujours « Aucun aperçu », cette image n'a pas pu être récupérée : vous pouvez la re-téléverser.",
        "button_restore": "Restaurer les images",
        "button_requested": "Restauration demandée",
        "helper_within_3_days": "Les aperçus sont mis à jour sous 3 jours."
      },
      "errors": {
        "load_failed": "Nous n'avons pas pu charger vos modèles. Veuillez actualiser la page et réessayer."
      }
    },
    "my_sales": {
      "earnings_detail": {
        "generate_report": "Générer le rapport",
        "report_sent_confirmation": "Le rapport sera bientôt envoyé à votre adresse e-mail !",
        "errors": {
          "sales_load_failed": "Impossible de charger les revenus des ventes.",
          "downloads_load_failed": "Impossible de charger les revenus des téléchargements.",
          "subscription_earnings_load_failed": "Impossible de charger les revenus d'abonnement."
        }
      },
      "leave_program_modal": {
        "header": "Quitter le programme Maximisez vos revenus",
        "primary_action": "Quitter le programme Maximisez vos revenus",
        "cancel": "Annuler",
        "description": "Êtes-vous sûr de vouloir arrêter de participer au programme Maximisez vos revenus ?",
        "bullet_models": "Tous vos modèles ne participeront plus aux revenus d'abonnement",
        "bullet_promotion": "Vous ne serez pas inclus dans les accords d'entreprise, de partage de revenus, de participation ou de rémunération alternative",
        "bullet_revenue": "Vous continuerez à gagner grâce aux ventes standard du marketplace comme d'habitude",
        "warning_title": "Important : Logique des revenus mensuels",
        "warning_active_deals": "La participation est enregistrée à 00h00 le 1er jour de chaque mois",
        "warning_pending_payouts": "Si vous partez pendant le mois, les revenus du mois en cours ne seront pas affectés",
        "warning_re_enroll": "Les changements prennent effet à partir du prochain cycle mensuel",
        "warning_historical_data": "Les fonds de revenus sont calculés mensuellement en fonction des téléchargements réels au cours de ce mois",
        "info_line": "Vos revenus du mois en cours sont sécurisés et seront versés selon le calendrier de paiement standard."
      }
    }
  },
  "items": {
    "last_card": {
      "text": "Impossible de trouver ce que vous cherchez?",
      "button_text": "Demander un modèle 3D sur mesure"
    }
  },
  "model": {
    "download_limit_exceeded": "Vous avez dépassé votre limite quotidienne de téléchargements. Veuillez réessayer demain. Cette limite ne s'applique pas aux utilisateurs ayant effectué un achat au cours des 12 derniers mois.",
    "subscription": {
      "limit_reached_detailed": "Vous avez atteint votre limite de {{limit}} téléchargements pour ce mois. Votre limite est réinitialisée le {{reset_date}}. Pour télécharger plus de modèles maintenant, vous pouvez les acheter individuellement.",
      "limit_reached_detailed_no_date": "Vous avez atteint votre limite de {{limit}} téléchargements pour ce mois. Pour télécharger plus de modèles maintenant, vous pouvez les acheter individuellement."
    }
  },
  search_page: {
    seo_area: {
      by_relevance: 'Par pertinence :',
      by_extension: 'Par extension :',
      by_style: 'Par style :',
      by_type: 'Par type :',
    },
    results: {
      empty: 'Aucun modèle ne correspond à vos filtres.',
      error: 'Une erreur s\'est produite lors du chargement des résultats. Veuillez réessayer.',
      pagination: 'Pages de résultats de recherche',
      showing: 'Affichage de {{start}}-{{end}} sur {{total}}',
      per_page: 'Par page',
      first_page: 'Aller à la première page',
      previous_page: 'Aller à la page précédente',
      next_page: 'Aller à la page suivante',
      last_page: 'Aller à la dernière page',
      page_input: 'Aller à la page',
      results_count: '{{total}} résultats',
    },
    filters: {
      poly_count: {
        title: 'Nombre de polygones',
        title_with_count: 'Nombre de polygones ({{count}})',
        low_poly_label: 'Low-poly',
        low_poly_value: 'jusqu\'à 20k',
        mid_poly_label: 'Mid-poly',
        mid_poly_value: '20k - 100k',
        high_poly_label: 'High-poly',
        high_poly_value: '100k - 1M+',
        reset: 'Réinitialiser',
        checkboxes_group_label: 'Options de plage de polygones',
        info_tooltip: 'Le nombre de polygones est le total de polygones composant un modèle 3D.\n\nLow-poly : jusqu\'à 20k — idéal pour le temps réel (jeux, mobile, AR/VR).\nMid-poly : 20k – 100k — équilibré pour la plupart des usages en production.\nHigh-poly : 100k – 1M+ — idéal pour les rendus, le cinéma et la visualisation produit.',
      },
      style: {
        title: 'Style',
        title_with_count: 'Style ({{count}})',
        find_placeholder: 'Rechercher des styles...',
        no_matches: 'Aucun résultat',
        reset: 'Réinitialiser',
        tags_group_label: 'Options de style',
        show_more: 'Afficher plus',
        show_less: 'Afficher moins',
        groups: {
          era: 'Époque',
          genre: 'Genre',
          rendering: 'Rendu',
          look: 'Look',
          surface: 'Surface',
          purpose: 'Usage',
          form: 'Forme',
          subject: 'Sujet',
        },
      },
      features: {
        title: 'Caractéristiques',
        title_with_count: 'Caractéristiques ({{count}})',
        search_placeholder: 'Rechercher des caractéristiques...',
        no_matches: 'Aucun résultat',
        reset: 'Réinitialiser',
        game_ready: 'Prêt pour le jeu',
        with_renders: 'Avec rendus',
        simulation_ready: 'Prêt pour la simulation',
        show_more: 'Afficher plus',
        show_less: 'Afficher moins',
      },
      size: {
        title: 'Taille',
        unit: 'Unité',
        units: {
          cm: 'Centimètres (cm)',
          in: 'Pouces (in)',
          mm: 'Millimètres (mm)',
        },
        whole_print_size: 'Taille d\'impression totale',
        largest_print_size: 'Plus grande taille d\'impression',
        width: 'Largeur (X)',
        depth: 'Profondeur (Y)',
        height: 'Hauteur (Z)',
        quick_select: 'Sélection rapide',
        presets: {
          under_5: '< 5 cm',
          range_5_15: '5 - 15 cm',
          range_15_30: '15 - 30 cm',
          range_30_50: '30 - 50 cm',
          range_50_100: '50 - 100 cm',
          over_100: '100 cm +',
        },
        reset: 'Réinitialiser',
      },
      categories: {
        title: 'Catégories',
      },
      date_published: {
        title: 'Date de publication',
        all_time: 'Toute la période',
        last_24_hours: 'Dernières 24 heures',
        last_7_days: '7 derniers jours',
        last_month: 'Le mois dernier',
        last_3_months: '3 derniers mois',
        last_6_months: '6 derniers mois',
        last_year: 'L\'année dernière',
        custom: 'Choisir la date manuellement',
        start_date: 'Date de début',
        end_date: 'Date de fin',
        previous_month: 'Mois précédent',
        next_month: 'Mois suivant',
        cancel: 'Annuler',
        apply: 'Appliquer',
      },
      designers: {
        title: 'Designer',
        search_placeholder: 'Rechercher un designer...',
        following: 'Designers que vous suivez',
        following_indicator: 'Suivi',
        top: 'Meilleurs designers',
        models_count: '({{count}} modèles)',
        loading: 'Chargement des designers...',
        searching: 'Recherche de designers...',
        no_results: 'Aucun designer trouvé.',
        no_following: 'Vous ne suivez encore aucun designer',
        show_more: 'Afficher plus',
      },
      advanced: {
        title: 'Filtres avancés',
        group_label: 'AVANCÉ',
        personal_group_label: 'PERSONNEL',
        purchases_group_label: 'ACHATS',
        packs: 'Packs',
        has_marmoset: 'Avec visionneuse 3D',
        has_video: 'Avec vidéo',
        cgt_standard: 'CGT Standard',
        wish_list_only: 'Liste de souhaits uniquement',
        liked_models_only: 'Modèles aimés uniquement',
        exclude_purchased_items: 'Exclure les articles achetés',
        purchased_items_only: 'Articles achetés uniquement',
      },
      file_format: {
        title: 'Format de fichier',
        search_placeholder: 'Saisir pour rechercher...',
        show_more: 'Afficher plus',
        show_less: 'Afficher moins',
      },
      price: {
        title: 'Prix',
        on_sale: 'Articles en promotion',
        with_subscription: 'Articles d\'abonnement',
        min_price: 'Prix min.',
        max_price: 'Prix max.',
        ranges: {
          free: 'Gratuit',
          range_2_10: '$2 - $10',
          range_10_20: '$10 - $20',
          range_20_50: '$20 - $50',
          range_50_100: '$50 - $100',
          more_than_100: '$100+',
        },
      },
      license: {
        title: 'Licences',
        group_label: 'LICENCES',
        ai_usage_group_label: 'UTILISATION DE L\'IA',
        all: 'Toutes les licences',
        royalty_free: 'Libre de droits',
        editorial: 'Usage éditorial',
        custom: 'Personnalisée',
        ai_usage_allowed: 'Utilisation de l\'IA autorisée',
      },
      quality: {
        title: 'Qualité',
        content_source_title: 'Source du contenu',
        tooltip: 'Basic – ressources d\'entrée de gamme avec une géométrie et des matériaux plus simples.\nPremium – ressources de meilleure qualité avec une topologie propre et des matériaux détaillés.\nPro – ressources haut de gamme conçues selon des standards professionnels et de production.\n\nGénéré par IA – afficher uniquement les ressources créées avec des outils d\'IA.\nCréé par des humains – afficher uniquement les ressources créées par des designers humains.',
        levels: {
          any: 'Tous',
          basic: 'Basic',
          premium: 'Premium',
          pro: 'Pro',
        },
        content_source: {
          all: 'Tout le contenu',
          ai_generated: 'Généré par IA',
          human_created: 'Créé par des humains',
        },
      },
      more_filters: {
        trigger_label: 'Filtres',
        trigger_label_with_count: 'Filtres ({{count}})',
        desktop_title: 'Plus de filtres',
        modal_title: 'Tous les filtres',
        close_label: 'Fermer les filtres',
        reset: 'Réinitialiser',
        apply_filters: 'Appliquer les filtres',
      },
      asset_type: {
        group_label: 'Type de ressource',
        all: 'Tout',
        three_d_only: '3D uniquement',
        three_d_only_short: '3D',
        three_d_print_only: 'Impression 3D uniquement',
        three_d_print_only_short: 'Impression 3D',
      },
      clear_all: 'Effacer tous les filtres',
      sorting: {
        title: 'Tri',
        trending: 'Tendances',
        top_sellers: 'Meilleures ventes',
        reset: 'Réinitialiser',
        best_match: 'Meilleure correspondance',
        default_option: 'Par défaut',
        newest: 'Plus récents',
        oldest: 'Plus anciens',
        lower_price: 'Prix le plus bas',
        higher_price: 'Prix le plus élevé',
      },
      secondary: {
        group_label: 'Filtres secondaires',
        search_placeholder: 'Rechercher dans les résultats...',
      },
      technical_attributes: {
        group_label: 'Attributs techniques',
        animated: 'Animé',
        rigged: 'Riggé',
        low_poly: 'Low-poly',
        pbr: 'PBR',
        simulation_ready: 'Prêt pour la simulation',
      },
      print_attributes: {
        group_label: 'Attributs d\'impression',
        with_makes: 'Avec Makes',
        three_d_print_verified: 'Impression 3D vérifiée',
        simulation_ready: 'Prêt pour la simulation',
      },
      tags: {
        title: 'Suggestions de tags',
        more: 'Plus',
        title_with_count: 'Suggestions de tags ({{count}})',
        tags_group_label: 'Suggestions de tags',
        find_placeholder: 'Rechercher des catégories...',
        no_matches: 'Aucun résultat',
        show_more: 'Afficher plus',
        show_less: 'Afficher moins',
        reset: 'Réinitialiser',
      },
    },
  },
}
// jshint ignore: end
